export enum YardReportOrderByField {
  Plate = 'Plate',
  EntryDate = 'EntryDate',
  EstimateLeaveDate = 'EstimateLeaveDate',
  Customer = 'Customer',
}

export enum YardReportOrderDirection {
  Asc = 'Asc',
  Desc = 'Desc',
}

export enum YardReportDateType {
  EntryDate = 'EntryDate',
  EstimateLeaveDate = 'EstimateLeaveDate',
}
